import React, { useEffect, useState } from 'react'
import './todolist.css'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import profile from '../../../assets/profile.png'
import {getAllTasks} from '../../../api/taskApi'
import { useDispatch, useSelector } from 'react-redux'
import {handleAddAllTask} from '../../../state/taskSlice'
import LinearProgress from '@mui/material/LinearProgress';



const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        renderCell: (param)=>{
            return (
                <div className='todolist__table-profile'>
                    <img src={!param?.row?.user?.profilePic ? profile
                    : `https://backend.aspomportal.com/upload/${param?.row?.user?.profilePic}`} 
                    alt={param?.row?.user?.firstName + ' ' + param?.row?.user?.lastName} 
                    className="todolist__table-img" />
                    <div className="todolist__table-profile_list">
                        <h4 className="todolist__table-profile_name">
                            {param?.row?.user?.firstName + ' ' + param?.row?.user?.lastName}
                        </h4>
                        <span className="todolist__table-profile_email">
                            {param?.row?.role}
                        </span>
                    </div>
                </div>
            )
        }
    },
    {
        field: 'employeeId',
        headerName: 'Employee ID',
        width: 150,
        renderCell: (param)=>(
            <span>
                {param?.row?.user?.staffId}
            </span>
        )
    },
    {
        field: 'department',
        headerName: 'Department',
        width: 140,
        renderCell: (param)=>(
            <span>
                {param?.row?.user?.department}
            </span>
        )
    },
    {
        field: 'missed',
        headerName: 'Missed',
        width: 130,
        renderCell: (param)=>(
            <span>
                {param?.row?.totalMissed}
            </span>
        )
    },
    {
        field: 'submitted',
        headerName: 'Submitted',
        width: 130,
        renderCell: (param)=>(
            <span>
                {param?.row?.totalDaysTasksSubmitted}
            </span>
        )
    },
    {
        field: 'Working Days',
        headerName: 'Working Days',
        width: 130,
        renderCell: (param)=>(
            <span>
                {param?.row?.totalWorkingDays}
            </span>
        )
    },
    {
        field: 'Holidays',
        headerName: 'Holidays',
        width: 130,
        renderCell: (param)=>(
            <span>
                {param?.row?.totalHolidays}
            </span>
        )
    },
];


const Todolist = () => {
    const {user} = useSelector((state)=>state.user)
    const {allTasks} = useSelector((state)=>state.task)
    const [value, setValue] = useState('')
    const dispatch = useDispatch()
    const [selectedMonth, setSelectedMonth] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleAllTasks = async ()=>{
        setIsLoading(true)
        try{
            const month = selectedMonth || getCurrentMonth() 
            const res = await getAllTasks(user?.token, month)
            dispatch(handleAddAllTask(res?.data))
            setIsLoading(false)
        }catch(error){
            setIsLoading(false)
            console.log(error)
        }
    }

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
    };

    // const filterItems = allTasks?.filter((item)=>{
    //     return item?.user?.firstName?.toLowerCase().includes(value.toLowerCase())
    //     || item?.user?.lastName?.toLowerCase().includes(value.toLowerCase())
    // })

    const getCurrentMonth = () => {
        const date = new Date();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add padding to ensure two digits
        return month;
    };

    useEffect(()=>{
        handleAllTasks()
    },[selectedMonth])
  return (
    <section className='todolist'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Employee Todolist | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Employee Todolist <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    Employee Todolist for {moment().format('MMMM YYYY')}
                </p>
            </div>
        </div>

        <div className="todolist__container">

            <div className="todolist__items">
                <div className="todolist__search">
                    <h4 className="todolist__search-title">
                        Todolist for {moment().format('MMMM YYYY')}
                    </h4>
                    <div className="todolist__search-box">
                        <span className="todolist__search-span">Search:</span>
                        <select id="month" value={selectedMonth} 
                        onChange={handleMonthChange}
                        className="report__search-input">
                            <option value="">-- Select Month --</option>
                            <option value="01">January</option>
                            <option value="02">February</option>
                            <option value="03">March</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">August</option>
                            <option value="09">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                        </select>
                    </div>
                </div>
                {isLoading && <LinearProgress sx={{width: '100%'}}/>}
                <div className="todolist__table">
                    <DataGrid
                        getRowId={(rows => rows?.user?._id)}
                        rows={allTasks ?? []}
                        columns={columns}
                        initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 5,
                            },
                        },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                        getRowHeight={() => 'auto'} 
                        sx={{
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                                py: 0.5,
                            },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                                py: '5px',
                            },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                                py: '10px',
                            },
                        }}
                        experimentalFeatures={{ lazyLoading: true }}
                    />
                </div>
            </div>
        </div>
    </section>
  )
}

export default Todolist